module.exports = __webpack_public_path__ + "img/program-target.c12d3dce.png";